import { render } from "./DirectDebitMandatesTable.vue?vue&type=template&id=3cc55d16"
import script from "./DirectDebitMandatesTable.vue?vue&type=script&lang=js"
export * from "./DirectDebitMandatesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__